module.exports = __webpack_public_path__ + "assets/img/goods_adv6.44f3897c.jpg";